import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Star, MessageSquare } from "lucide-react";
import { SeloDestaque } from "@/components/SeloDestaque";

const Estrelas = ({ n, size = 14 }) => (
  <span className="inline-flex gap-0.5">
    {[1, 2, 3, 4, 5].map(i => (
      <Star key={i} size={size} className={i <= Math.round(n) ? "text-[#FF6700] fill-[#FF6700]" : "text-slate-300"} />
    ))}
  </span>
);

export default function Avaliacoes() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/painel/avaliacoes").then(r => setD(r.data)).catch(e => toast.error(formatApiError(e)));
  }, []);
  if (!d) return <div className="p-8 text-sm text-muted-foreground">Carregando…</div>;
  return (
    <div className="p-8 max-w-4xl" data-testid="painel-avaliacoes">
      <div className="label-cap">Inteligência</div>
      <h1 className="font-heading font-extrabold text-3xl tracking-tighter mt-1">Avaliações dos Clientes</h1>
      <p className="text-sm text-muted-foreground mt-2">Notas e comentários dos clientes, agrupados por montador.</p>

      <div className="mt-6 border-2 border-[#142766] bg-white p-4 flex items-center gap-4" data-testid="avaliacoes-resumo">
        <div className="text-4xl font-extrabold text-[#142766]">{d.media_geral ?? "—"}</div>
        <div>
          {d.media_geral && <Estrelas n={d.media_geral} size={18} />}
          <div className="text-xs text-muted-foreground mt-0.5">{d.total} avaliação(ões) recebida(s)</div>
        </div>
      </div>

      {d.montadores.length === 0 && (
        <div className="mt-6 border border-dashed border-border bg-white p-10 text-center text-sm text-muted-foreground"
          data-testid="avaliacoes-vazio">Nenhuma avaliação recebida ainda.</div>
      )}

      <div className="space-y-4 mt-6">
        {d.montadores.map(m => (
          <div key={m.montador_id} className="border border-border bg-white" data-testid={`avaliacoes-montador-${m.montador_id}`}>
            <div className="p-4 flex flex-wrap items-center justify-between gap-2 border-b border-border">
              <div className="font-bold text-[#142766] flex items-center gap-2">
                {m.montador_nome || "Montador não atribuído"} <SeloDestaque show={m.destaque} />
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Estrelas n={m.media} /> <strong>{m.media}</strong>
                <span className="text-xs text-muted-foreground">({m.total})</span>
              </div>
            </div>
            <div className="divide-y divide-dashed divide-border">
              {m.avaliacoes.map((a, i) => (
                <div key={i} className="p-3 text-xs flex gap-3" data-testid={`avaliacao-item-${m.montador_id}-${i}`}>
                  <Estrelas n={a.estrelas} size={12} />
                  <div className="flex-1">
                    {a.comentario
                      ? <span className="italic">"{a.comentario}"</span>
                      : <span className="text-muted-foreground">sem comentário</span>}
                    <div className="text-[10px] text-muted-foreground mt-0.5">
                      {a.pim_code} · {a.cliente || "—"} {a.em && `· ${new Date(a.em).toLocaleDateString("pt-BR")}`}
                    </div>
                  </div>
                  {a.estrelas <= 3 && <MessageSquare size={13} className="text-red-500 shrink-0" title="Nota baixa" />}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
